import { VBadge } from 'vuetify/lib/components/VBadge';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBadge,{attrs:{"color":"info","dark":"","overlap":"","bottom":""}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.count))]),_c('sn-card',{attrs:{"show":true,"kind":_vm.kind}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }